export default {"src":"/_next/static/image/public/images/ic_calendar_orange.75e7cdc87570537b25b9988447cff33a.svg","height":30,"width":30};